import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiImageEditor = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-image-editor',
			name: 'AI Photo Editor online | Instant Photo Editing | Lift',
			description:
				'Professional AI photography editing online — remove background, erase objects, enhance images, and apply creative filters instantly. No design skills needed ',
			url: 'https://liftapp.ai/ai-image-editor',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-image-editor#product' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#howto' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#benefits' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#faq' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-image-editor#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-image-editor#product',
			name: 'AI Photo Editor Online',
			description:
				'Professional AI photography editing online — remove background, erase objects, enhance images, and apply creative filters instantly. No design skills needed ',
			url: 'https://liftapp.ai/ai-image-editor',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-image-editor#howto',
			name: 'How Lift AI Photo Editor Works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: "Import a photo from desktop, mobile, or Lift's media library.",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Select your edit',
					text: 'Pick from background removal, object eraser, upscaling, AI headshots, or creative filters.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Let AI enhance',
					text: "Lift's AI cleans up backgrounds, fixes lighting, removes distractions, and boosts details automatically.",
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download or share',
					text: 'Export watermark-free PNG/JPG files for social media, ads, or e-commerce listings.',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-image-editor#benefits',
			name: 'Who can benefit from Lift AI Photo Editor?',
			description:
				"Lift's AI Photo Editor helps creators, marketers, sellers, and everyday users craft professional visuals without design skills.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Content Creators & Influencers — Produce scroll-stopping Instagram posts, YouTube thumbnails, and TikTok content quickly with AI filters, background edits, and collage tools that boost engagement and grow your audience',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'E-commerce & Online Sellers — Create professional product photos with clean backgrounds, enhanced colors, and perfect aspect ratios for Amazon, Shopify, or Etsy listings that drive conversions and build customer trust',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Marketing Teams & Advertisers — Design eye-catching ad creatives, social media campaigns, and promotional materials with auto-enhancement, object removal, and custom filters — all without expensive design software',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Job Seekers & Professionals — Generate polished AI headshots for LinkedIn profiles, CVs, and professional portfolios that make a strong first impression on recruiters and clients',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Everyday Users — Anyone can transform personal photos effortlessly. Fix imperfections, enhance vacation photos, remove photobombers, or create fun edits for sharing with friends and family — no Photoshop skills required',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI photo editor enhancement comparison',
				description:
					'Before and after of Enhancer and Upscaler fixing portrait and group photos.',
			},
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-image-editor#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo Editor?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo Editor is a powerful online tool that uses AI to transform your images instantly. It offers professional features like background removal, object erasing, image upscaling, AI headshot generation, and creative filters — all without requiring design skills or expensive software.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift work for both generating and editing images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Simply upload your photo and choose from AI-powered editing features. Our advanced AI algorithms automatically analyze your image and apply professional-grade enhancements in seconds. The entire process runs in the cloud, so there's no software to download or manual editing needed — just instant, high-quality results.",
					},
				},
				{
					'@type': 'Question',
					name: 'What photo editing features does Lift offer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift includes a complete suite of AI-powered editing tools: background removal for clean cutouts, object eraser to remove unwanted elements, image upscaling for higher resolution, AI headshot generator for professional portraits, and creative filters to enhance your photos. All features work together seamlessly for comprehensive photo editing.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download my edited photos without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images edited in Lift can be exported without watermarks when you're on the Pro plan. Download them in high-resolution PNG or JPG format — ready for social media, print, advertising campaigns, or e-commerce listings.",
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-image-editor#why-lift',
			name: 'Why choose Lift AI Photo Editor',
			description:
				'Lift pairs pro-grade AI with intuitive tools so anyone can produce polished visuals fast.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI photo editor style variations preview',
				description:
					'Man transformed into playful clay and cartoon styles with Lift AI.',
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-image-editor#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-image-editor#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Image Editor',
					item: 'https://liftapp.ai/ai-image-editor',
				},
			],
		},
	],
};
